<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            备用金充值使用列表
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">备用金充值</el-button>
                    <el-button type="success" :disabled="disabledCut" @click.native="toggleModalEmploy">备用金使用</el-button>
                    <el-button type="danger" :disabled="disabledReturn" @click.native="toggleModalReturn">退费</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="width:200px;margin-right:10px"></el-input>
                        <el-select v-model="rechargeType" placeholder="请选择充值类型" style="width:200px;margin-right:10px">
                            <el-option
                                    v-for="item in typeValue"
                                    :key="item[0]"
                                    :label="item[1]"
                                    :value="item[0]">
                            </el-option>
                        </el-select>
                        <el-select v-model="type" clearable placeholder="请选择">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-date-picker
                            v-model="startTime"
                            type="date"
                            style="margin-left:10px;margin-right:10px;"
                            value-format="yyyy-MM-dd"
                            placeholder="开始日期" class="search">
                        </el-date-picker>
                        <el-date-picker
                            v-model="endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期" class="search">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
                
            </div>
            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">
                        <el-table-column label="老人姓名" prop="elderlyName" width="100"></el-table-column>
                        <el-table-column label="手机号" prop="elderlyDTO.phone" width="120"></el-table-column>
                        <el-table-column label="身份证号" prop="elderlyDTO.idCard" width="180"></el-table-column>
                        <el-table-column label="地区" prop="elderlyDTO.areaName" ></el-table-column>
                        <el-table-column label="详细地址" prop="elderlyDTO.address" ></el-table-column>
                        <el-table-column prop="money" label="充值或使用金额（元）" width="200"></el-table-column>
                        <el-table-column prop="remarks" label="备注" ></el-table-column>
                        <el-table-column prop="type" label="类型" >
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.type==1">充值</el-tag>
                                <el-tag v-if="scope.row.type==2" type="success">使用</el-tag>
                                <el-tag type="danger" v-if="scope.row.type==3">退费</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="rechargeType" label="收款类型" >
                            <template slot-scope="scope">
                                <span v-if="scope.row.rechargeType==0">无</span>
                                <span v-if="scope.row.rechargeType==1">现金</span>
                                <span v-if="scope.row.rechargeType==2">支付宝</span>
                                <span v-if="scope.row.rechargeType==3">微信</span>
                                <span v-if="scope.row.rechargeType==4">刷卡</span>

                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="创建时间"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Employ ref="myEmploy" v-show="showModalEmploy" v-on:closeEmploy="closeEmploy" v-on:getList="getList"></Employ>
        <Return ref="myReturn" v-show="showModalReturn" v-on:closeReturn="showModalReturn=false" v-on:getList="getList"></Return>
    </div>
</template>

<script>

    import {timeStr,timefilters,getBeforeDate} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Add from "./Add";
    import Employ from "./Employ";
    import Return from "./Return";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                startTime:getBeforeDate(-30),
                endTime:getBeforeDate(0),
                menuButtonList:null,
                disabledAdd:true,
                disabledCut:true,
                disabledReturn:true,
                showModalAdd:false,
                showModalEmploy:false,
                showModalReturn:false,
                batchDialog:false,
                tableData:null,
                elderlyName:null,
                type:-1,
                options: [{
                value: -1,
                label: '全部'
                }, {
                value: 1,
                label: '充值'
                }, {
                value: 2,
                label: '使用'
                }],
                rechargeType:-1,
                batchFileList:[],
                typeValue:[[-1,'全部类型'],[1,'现金'],[2,'支付宝'],[3,'微信'],[4,'刷卡']],
                datetimerangeValue:[],
                uploadUrl:this.$institutionUrl+'ImportExcel/RechargeImport',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                idNumber:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
            }
        },
        components:{
            Add,Employ,Return
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="备用金充值"){
                            this.disabledAdd = false;
                        }
                        if(menu[i].buttonName=="备用金使用"){
                            this.disabledCut = false;
                            this.disabledReturn = false;
                        }
                    }
                }
            },
            formatterTime(row, column, cellValue) {
                return timefilters(cellValue)
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEmploy:function(){
                this.showModalEmploy = !this.showModalEmploy;
                this.$refs.myEmploy.init();
            },
            toggleModalReturn:function(){
                this.showModalReturn = !this.showModalReturn;
                this.$refs.myReturn.init();
            },
            closeEmploy:function(){
                this.showModalEmploy = !this.showModalEmploy;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ImprestRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        type:this.type,
                        rechargeType:this.rechargeType,
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            submitUpload(){
                this.$refs.upload.submit();
            },
            closeBatchDialog(){
                this.$refs.upload.clearFiles();
            },
            handleRemove(){

            },
        }
    }
</script>

<style lang="scss" scoped>
    .a{
        color: rgb(0, 119, 255);
    }
    .b{
        color: rgb(25, 252, 119);
    }
    .b{
        color: rgb(248, 18, 87);
    }

</style>
